const $ = window.jQuery;
const mobiles = window.matchMedia("(max-width: 767px)");

export function filterEvent() {
    let nom_id = [];
    const filterClear = $(".js-filter-clear");
    let dateRange = [];

    function formatDate(time) {
        for (let i = 0; i < time.length; i++) {
            let date = new Date(time[i]);
            const day = date.toLocaleString("ru", {day: "2-digit"});
            const month = date.toLocaleString("ru", {month: "2-digit"});
            const year = date.toLocaleString("ru", {year: "2-digit"});
            date = `${day}-${month}-${year}`;
            dateRange.push(date);
        }
        if (dateRange) {
            dateRange = dateRange.join(" — ");
        }
        return dateRange;
    }

    let flatSelectedDates;

    function getSelectedDates() {
        flatSelectedDates = Array.from(new Set(flatSelectedDates));
        return flatSelectedDates;
    }

    function filter(dateRange = []) {
        const eventsItems = $("#js-event-items");
        eventsItems.html("");
        $.ajax({
            type: "GET",
            url: "/search",
            data: {dateRange, "objects": nom_id},
            beforeSend: () => {
                $("#js-overlay").show();
            },
            success: data => {
                const response = JSON.parse(data);
                if (response.html.trim()) {
                    eventsItems.html(response.html);

                    $(".events__message").hide();
                    $("#js-more").show();
                } else {
                    $(".events__message")
                        .text("Мероприятий нет")
                        .show();
                }
                if (response.eventsCount.length < 5) {
                    $("#js-more").hide();
                }
            },
            complete: () => {
                $("#js-overlay").hide();
            },
        });
    }

    const filterDate = $(".js-filter-date");

    const currentDate = new Date();
    currentDate.setDate(new Date().getDate() - 1);
    const btnAccept = '<button type="button" class="filter__date-apply btn">Применить</button>';
    const btnClear = '<button type="button" class="filter__date-reset"><svg class="filter__date-reset-icon">\n' +
        '                                <use xlink:href="#clear"></use>\n' +
        '                            </svg>\n' +
        '                            <span class="filter__date-reset-text">Сбросить</span></button>';
    const buttons = '<div class="filter__date-buttons">'
        .concat(btnAccept)
        .concat(btnClear, "</div>");
    const myFlat = $(".js-date-filter").flatpickr({
        mode: "range",
        enableTime: true,
        locale: "ru",
        clickOpens: false,
        plugins: [new confirmDatePlugin({})],
        disable: [
            {
                from: 1506710842947,
                to: currentDate,
            },
        ],
        onReady(selectedDates) {
            flatSelectedDates = selectedDates.map(item => {
                return new Date(item).getTime();
            });
            const container = $(".flatpickr-rContainer");
            container.append(buttons);
            $(".filter__date-apply").on("click", () => {

                $(".js-filter-clear").addClass("active");
                myFlat.close();
                dateRange = [];
                dateRange = formatDate(getSelectedDates());
                $(".filter__date-label").removeClass("active");
                $(".js-filter-input").removeClass("active");
                $.each($(".js-filter-input"), function () {
                    const checkbox = $(this);
                    checkbox.prop("checked", false);
                });
                filter(dateRange);
            });
            $(".filter__date-reset").on("click", () => {
                myFlat.clear();
                const eventsItems = $(".events__item");
                $.each(eventsItems, function () {
                    $(this).show();
                });
                flatSelectedDates = [];
                dateRange = [];
                filter();
                $(".filter__date-label").text("Выбрать дату");
            });

        },
        onClose: selectedDates => {
            if (!selectedDates.length) {
                return false;
            }
            const firstDate = selectedDates[0].toString();
            let lastDate;
            if (selectedDates[1]) {
                lastDate = selectedDates[1].toString();
            } else {
                selectedDates[1] = selectedDates[0];
            }
            filterDate.removeClass("alone");
            if (firstDate === lastDate || !lastDate) {
                filterDate.addClass("alone");
            }
            flatSelectedDates = selectedDates.map(item => {
                return new Date(item).getTime();
            });
            myFlat.setDate(selectedDates);
            return true;
        },
        onChange(selectedDates) {

            let day = selectedDates.map(item => {
                return item.getDate();
            });

            let month = selectedDates.map(item => {
                const numberOfMonth = new Date(item).getMonth();
                const months = ["Января", "Февраля", "Марта", "Апреля", "Мая", "Июня", "Июля", "Августа", "Сентября", "Октября", "Ноября", "Декабря"];
                return months[numberOfMonth];
            });

            day = Array.from(new Set(day));
            month = Array.from(new Set(month));

            if (day.length <= 1 && month.length <= 1) {
                $(".filter__date-label").text("".concat(day, " ").concat(month));
            } else if (day.length > 1 && month.length <= 1) {
                $(".filter__date-label").text("".concat(day[0], " \u2014 ").concat(day[1], " ").concat(month));
            } else if (day.length > 1 && month.length > 1) {
                $(".filter__date-label").text(
                    "".concat(day[0], " ").concat(month[0], " \u2014 ").concat(day[1], " ").concat(month[1]));
            }
        },
        onOpen: () => {
            if (
                $(".flatpickr-day.startRange")
                    .next()
                    .hasClass("inRange")
            ) {
                $(".flatpickr-day.startRange").addClass("not-alone");
            }
        },
    });

    $(".filter__date-label").on("click", function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            myFlat.close();
            if (mobiles.matches) {
                dateRange = [];
                dateRange = formatDate(getSelectedDates());
                filter(dateRange);
            }
        } else {
            $(this).addClass("active");
            myFlat.open();
        }
    });

    (function () {
        const filterDropdowns = $(".js-dropdown-filter");
        const filterDom = $("#js-filter");
        const checkboxes = $(".js-filter-input");
        const filterBtns = $(".dropdown__btn");
        const filterTitle = $("#js-filter-title");

        filterClear.on("click", function () {
            dateRange = [];
            nom_id = [];
            flatSelectedDates = [];
            $(".filter__date-label").removeClass("active");

            $.each(checkboxes, function () {
                const checkbox = $(this);
                checkbox.prop("checked", false);
            });
            $.each(filterBtns, function () {
                const filterBtn = $(this);
                const btnText = filterBtn.find(".filter__selected-text");
                const btnCount = filterBtn.find(".filter__selected-count");

                btnText.text(filterBtn.data("previous"));
                btnCount.text("");
            });

            $.each($(".filter__selected-count"), function () {
                const count = $(this);
                count.text("");
            });
            $(".events__message").text("").hide();
            $("#js-more").show();
            filterClear.removeClass("active");
            $(".filter__date-reset").trigger("click");
            $(".filter__date-label").text("Выбрать дату");
            $(".js-filter-input").removeClass("active");
        });

        $.each(filterDropdowns, function () {
            const filterDropdown = $(this);
            const filterData = filterDropdown.data("select");
            const filterBtn = filterDropdown.find(".dropdown__btn");
            const btnText = filterBtn.find(".filter__selected-text");
            const btnCount = filterBtn.find(".filter__selected-count");
            const checkboxes = filterDropdown.find(".checkbox__input");
            const reset = filterDropdown.find(".js-filter-reset");

            $.each(checkboxes, function () {
                const checkbox = $(this);
                const id = checkbox.data("id");

                let count = 0;

                checkbox.on("change", function () {
                    if (checkbox.prop("checked")) {
                        count++;
                        btnText.text(filterBtn.data("text"));
                        btnCount.text(Number(btnCount.text()) + 1);
                        filterClear.addClass("active");
                        if (filterData === "nom") {
                            nom_id.push(id);
                        }

                    } else {
                        count--;
                        btnCount.text(Number(btnCount.text()) - 1);
                        if (filterData === "nom") {
                            var indexArrUnit = nom_id.indexOf(id);
                            nom_id.splice(indexArrUnit, 1);
                        }
                        if (Number(btnCount.text()) === 0) {
                            btnText.text(filterBtn.data("previous"));
                            btnCount.text("");
                            $(".events__message").text("").hide();
                            $("#js-more").show();
                        }
                    }
                    dateRange = [];
                    dateRange = formatDate(getSelectedDates());
                    filter(dateRange);
                })
            });

            reset.on("click", (e) => {
                checkboxes.each((i, item) => {
                    item.checked = false;
                });
                var filterName = $(e.currentTarget).parents(".js-dropdown-filter").data("select");
                if (filterName === "nom") {
                    nom_id = [];
                }
                filter();
                btnText.text(filterBtn.data("previous"));
                btnCount.text("");
            });
        });

        filterTitle.on("click", function () {
            filterDom.toggleClass("active");
        })
    })();

    (function () {
        const inputs = $(".js-filter-input");

        $.each(inputs, (index, element) => {
            const input = $(element);
            input.on("change", () => {
                inputs.removeClass("active");
                input.addClass("active");
                const from = input.data("date-from");
                const to = input.data("date-to");
                dateRange = [];
                dateRange = `${from} — ${to}`;
                filter(dateRange);
                filterClear.addClass("active");
                myFlat.clear();
                $(".filter__date-label").text("Выбрать дату");
            });
        });
    })();
}
